<app-tabla
  [totalCount]="totalCount"
  [datos]="recorridos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay recorridos dinámicos', subtitle: 'Planificá un recorrido por puntos para asignarlo a un vehículo.' }"
></app-tabla>
